// eAPI spells the error body two different ways depending on which layer produces it.
// ExceptionHandlingMiddleware writes ErrorResponse with `JsonSerializer.Serialize` and the
// default options, so `EnterpriseApiException` (every Schedule_* code) arrives PascalCase on a
// 400. Endpoints that hand an ErrorResponse back through MVC instead — the v5 reCAPTCHA filter,
// the offices NotFound branches — pick up the web defaults and emit lower camel case. The
// generated swagger documents the lower-camel spelling for both, so read either.
// Both readers must stay in agreement: route.ts decides whether to alert on a response and
// scheduleAppointment.util.ts decides whether to fail the flow, and they read the same body.

// Status eAPI uses for EnterpriseApiException (every Schedule_* code) — scheduleAppointment.ts
// relies on this to distinguish an app-level error body from a transport failure.
export const SCHEDULE_ERROR_STATUS = 400;

function readField(data: unknown, pascalKey: string, camelKey: string): unknown {
  if (typeof data !== "object" || data === null) return null;
  const record = data as Record<string, unknown>;
  return record[pascalKey] ?? record[camelKey] ?? null;
}

export function readScheduleErrorCode(data: unknown): string | null {
  const code = readField(data, "ErrorCode", "errorCode");
  if (typeof code === "number") return String(code);
  return typeof code === "string" && code ? code : null;
}

export function readScheduleErrorMessage(data: unknown): string | null {
  const errors = readField(data, "Errors", "errors");
  return typeof errors === "string" && errors ? errors : null;
}
